import React from 'react'
import clsx from 'clsx'

type LoadingSpinnerProps = {
  size?: 'sm' | 'md'
  className?: string
}

export default function LoadingSpinner({ size = 'md', className }: LoadingSpinnerProps) {
  return (
    <div
      className={clsx(
        'inline-block animate-spin rounded-full border-solid border-primary-600 border-r-transparent motion-reduce:animate-[spin_1.5s_linear_infinite]',
        size === 'sm' ? 'h-4 w-4 border-2' : 'h-8 w-8 border-4',
        className
      )}
      role="status"
      aria-hidden="true"
    />
  )
}
